module.exports = __webpack_public_path__ + "img/spider-black-widow.ad1bed8a.svg";